var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktokIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.321 5.562a5.124 5.124 0 0 1-.443-.258 6.228 6.228 0 0 1-1.137-.966c-.849-.849-1.317-1.958-1.317-3.123C16.424.496 15.928 0 15.309 0h-3.068c-.619 0-1.115.496-1.115 1.115v11.615c0 1.728-1.405 3.133-3.133 3.133s-3.133-1.405-3.133-3.133 1.405-3.133 3.133-3.133c.619 0 1.115-.496 1.115-1.115V5.414c0-.619-.496-1.115-1.115-1.115C3.729 4.299 0 8.028 0 12.73s3.729 8.431 8.431 8.431 8.431-3.729 8.431-8.431V8.847c1.137.849 2.544 1.317 4.069 1.317.619 0 1.115-.496 1.115-1.115V5.981c0-.619-.496-1.115-1.115-1.115-.372 0-.729-.062-1.069-.161-.341-.099-.663-.243-.954-.443z",
    fill: "#FFD700"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktokIcon);
export default __webpack_public_path__ + "static/media/tiktok-icon.dfe0c7bfc2893389e931c3175dff538c.svg";
export { ForwardRef as ReactComponent };